// extracted by css-extract-rspack-plugin
export default {"slashCommandContainer":"SlashCommandsProvider-module__slashCommandContainer__T0XL0cq"};